import profile from '@/mixins/profile'

export default {
  mixins: [profile],

  computed: {
    statusNotificationMessage () {
      const profile = this.profile

      if (profile.status === 'NEW') {
        return {
          text: this.$i18n.t('components.DashboardNotification.fillProfile'),
          type: 'warning'
        }
      }

      if (profile.status === 'VERIFICATION') {
        return {
          text: this.$i18n.t('components.DashboardNotification.profileIsBeingVerified'),
          type: 'warning'
        }
      }

      if (profile.status === 'CORRECTION') {
        return {
          text: this.$i18n.t('components.DashboardNotification.youHaveReturnedProfileBack'),
          type: 'warning'
        }
      }

      if (profile.status === 'OUT_PLATFORM') {
        return {
          text: this.$i18n.t('components.DashboardNotification.profileOutDesc'),
          type: 'error'
        }
      }

      if (profile.status === 'DEACTIVATED') {
        return {
          text: this.$i18n.t('components.DashboardNotification.companyDeactivated'),
          type: 'error'
        }
      }

      if (profile.status === 'READY' && profile.active) {
        return {
          text: this.$i18n.t('components.DashboardNotification.theProfileIsVerifiedAndPublished'),
          type: 'success'
        }
      }

      if (profile.status === 'READY' && !profile.active) {
        return {
          text: this.$i18n.t('components.DashboardNotification.theProfileIsVerifiedAndNotPublishedYet'),
          type: 'warning'
        }
      }

      if (profile.status !== 'READY' && !profile.active) {
        return {
          text: this.$i18n.t('components.DashboardNotification.fillProfile'),
          type: 'warning'
        }
      }

      return null
    }
  }
}
